import {useEffect} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
// import {Route, Switch, withRouter} from "react-router-dom";
import {useLocation, withRouter} from "react-router-dom";

import {
  setLookActiveCategory,
  setLookActiveFeature,
  setLookOpened, setLookOverlayOpened,
  setLookPageOpened
} from "../../actions/lookFunctions";
// import LookRoutingURLParse from "./lookRoutingURLParse";
// import {ROUTES} from "../../routes";
import {getParsedLookUrl, navFeatureCLick} from "./lookNavigation/lookFunctions";
import {updateCanvasCount} from "../../actions/actionFunctions";
import {getCurrentLayout} from "../appLayout";
import {LOOK_OPENED_TYPES, LOOK_OVERLAYS} from "./core/constants";
import {ROUTES} from "../../routes";
import {getPartIdFromLixilCategoryName} from "./lookLixilCategories";
import {getDefaultPresetByLook} from "./lookNavigation/lookFunctions2";
import {
  applyNewPreset,
  clickOnSimilarFeatures,
  getApplyToLogic,
  getShowMatchRadio
} from "./lookNavigation/lookNavigationFunctions";
import {getFeatureIsLocked} from "../../misc/helpers";
import {loaderDisable, loaderEnable} from "../ui/loaderView";
import {getFeatureFromTheBackendBySku} from "../../api/look-api";
import {IS_PRODUCT_JOURNEY} from "../../config";

let skusRequested = [];
let firstTimeLoaded = false;

/**
 * this class reacts to all route changes and dispatching changes to redux
 **/
const LookRouting = (props) => {

  const {activePreset, bvPresets, setLookOpened, lookOpened, lookActiveFeature, setLookActiveFeature,
    setLookActiveCategory, lookActiveCategory, lookPageOpened, setLookPageOpened, wizardActiveItem,
    visualizersLoadedLength, updateCanvasCount, loadedPresets, lookOverlayOpened, setLookOverlayOpened} = props;
    // visualizersLoadedLength, imageCanvas, canvasScale, setCanvasScale} = props;

  let location = useLocation();
  let timeOut = 0;

  const lookHistoryListener = async () => {
    // console.log("location", location);
    if (location && location.pathname) {

      if (location.pathname === "/") {
        if (lookOpened) {
          setLookOpened(null);
        }
        if (lookActiveFeature) {
          setLookActiveFeature(null);
        }
        if (lookActiveCategory) {
          setLookActiveCategory("");
        }
        if (lookPageOpened) {
          setLookPageOpened("");
        }
        // revertFeatureBeforeChange(updateCanvasCount);
        // if (canvasScale > 1) {
        //   zoomCanvasOut(imageCanvas, setCanvasScale);
        // }
        return
      } else {
        if (lookOverlayOpened === LOOK_OVERLAYS.aiPanel) {
          setLookOverlayOpened("");
        }
      }

      const layout = getCurrentLayout();
      let {lookIdFromUrl, featureGroupFromUrl, skuFromUrl} = getParsedLookUrl(location.pathname);

      // console.log("lookIdFromUrl, featureGroupFromUrl, skuFromUrl", lookIdFromUrl, featureGroupFromUrl, skuFromUrl);

      let categorySet = false;
      let featureSet = false;
      let layoutChanged = false;

      if (visualizersLoadedLength && lookIdFromUrl) {
        const preset = getDefaultPresetByLook(bvPresets, lookIdFromUrl);
        const activePresetState = bvPresets.find(preset => preset.id === activePreset);
        if (preset && preset.id && (preset.id !== activePreset) && activePresetState && (activePresetState.lookId !== lookIdFromUrl)) {
          // && (presetIdFromUrl !== activePreset)
          //   && bvPresets[presetIdFromUrl - 1]
          //   && (bvPresets[presetIdFromUrl - 1].id !== layout.id)
          layoutChanged = true;
          await applyNewPreset(preset, loadedPresets);
        }
      }
      if (skuFromUrl && !wizardActiveItem) {
        const featureGroupPartId =  featureGroupFromUrl ? featureGroupFromUrl.replace(/-/gi, "_") : ""
        let featureFound = lookActiveFeature && (lookActiveFeature.dbFeature.sku === skuFromUrl
          || lookActiveFeature.dbFeature.sharedFeatureName === skuFromUrl)
          ? lookActiveFeature
          : layout.getFeatureBySku(skuFromUrl, featureGroupPartId)
          || layout.getFeatureBySku(skuFromUrl, featureGroupPartId, false, true);
        if (!featureFound && !skusRequested.includes(skuFromUrl)
          && (featureGroupFromUrl || !layout.getFeatureGroupByPartId(skuFromUrl.replace(/-/gi, "_")))) {
          if (!visualizersLoadedLength) {
            loaderEnable();
          }
          featureFound = await getFeatureFromTheBackendBySku(skuFromUrl, featureGroupFromUrl);
          if (!visualizersLoadedLength) {
            loaderDisable();
          }
        }
        if (featureFound) {
          featureSet = featureFound;
          if (!firstTimeLoaded && getFeatureIsLocked(featureSet)) {
            firstTimeLoaded = true;
            featureSet.dbFeature.unlocked = true;
            const loadedDbFeatures = layout.allDbFeatures[featureSet.dbFeature.groupName?.toLowerCase()];
            if (loadedDbFeatures && loadedDbFeatures.length) {
              for (let i = 0; i < loadedDbFeatures.length; i++) {
                if (loadedDbFeatures[i].sharedFeatureName === featureSet.dbFeature.sharedFeatureName) {
                  loadedDbFeatures[i].unlocked = true;
                }
              }
            }
          }
          if (!lookActiveFeature || (lookActiveFeature.dbFeature.sharedFeatureName !== featureFound.dbFeature.sharedFeatureName)) {
            setLookActiveFeature(featureFound);
          }
          if (IS_PRODUCT_JOURNEY) {
            if (featureGroupFromUrl) {
              setLookActiveCategory(featureFound.partId);
              categorySet = true;
            }
          } else {
            setLookActiveCategory(featureFound.partId);
            categorySet = true;
          }
          if (!lookOpened) {
            setLookOpened(LOOK_OPENED_TYPES.featureZoom);
          }
        }
      }
      if ((featureGroupFromUrl || skuFromUrl) && !categorySet) {
        if (!featureGroupFromUrl) {
          featureGroupFromUrl = getPartIdFromLixilCategoryName(skuFromUrl);
          if (featureGroupFromUrl) {
            const featureGroupFound = layout.getFeatureGroupByPartId(featureGroupFromUrl);
            if (!featureSet && featureGroupFound && featureGroupFound.activeFeature) {
              featureSet = featureGroupFound.activeFeature;
              setLookActiveFeature(featureGroupFound.activeFeature);
            }
          } else if (!IS_PRODUCT_JOURNEY) {
            const featureGroupFound = layout.getFeatureGroupByPartId(skuFromUrl.replace("-", "_"));
            if (featureGroupFound) {
              setLookActiveCategory(featureGroupFound.partId);
              if (!lookOpened) {
                setLookOpened(LOOK_OPENED_TYPES.featureZoom);
              }
              // categorySet = true;
            }
          }
          // console.log("featureGroupFromUrl", featureGroupFromUrl);
        }
        if (featureGroupFromUrl && !wizardActiveItem) {
          let featureGroupFound = layout.getFeatureGroupByPartId(featureGroupFromUrl)
            || layout.getFeatureGroupByPartId(getPartIdFromLixilCategoryName(featureGroupFromUrl));
          if (!featureSet && featureGroupFound && featureGroupFound.activeFeature) {
            featureSet = featureGroupFound.activeFeature;
            setLookActiveFeature(featureGroupFound.activeFeature);
          }
          if (!lookOpened) {
            setLookOpened(LOOK_OPENED_TYPES.featureZoom);
          }
          if (featureGroupFound && featureGroupFound.partId !== lookActiveCategory) {
            setLookActiveCategory(featureGroupFound.partId);
          }
        } else if (IS_PRODUCT_JOURNEY && lookActiveCategory) {
          setLookActiveCategory("");
        }
      } else {
        if (layoutChanged && lookOpened) {
          if (!featureGroupFromUrl) {
            setLookOpened(null);
            // revertFeatureBeforeChange(updateCanvasCount);
          }
        }
        if (lookActiveFeature && !skuFromUrl) {
          setLookActiveFeature(null);
        }
        if (IS_PRODUCT_JOURNEY) {
          if (lookActiveCategory && !featureGroupFromUrl) {
            setLookActiveCategory("");
          }
        } else {
          if (lookPageOpened && Object.values(ROUTES).every(route => location.pathname !== route)) {
            setLookPageOpened("");
          }
        }

        // if (!skuFromUrl && !lookActiveCategory && !lookPageOpened
        //   && Object.values(ROUTES).every(route => location.pathname !== route)
        // ) {
        //   if (IS_PRODUCT_JOURNEY) {
        //     setLookPageOpened(ROUTES.category)
        //   }
        // }
        if (IS_PRODUCT_JOURNEY) {
          if (!skuFromUrl && !lookActiveCategory && !lookOpened && [ROUTES.view, ROUTES.rooms].some(route => location.pathname === route)) {
            setLookOpened(true);
          }
          if (lookPageOpened && [ROUTES.view, ROUTES.rooms].some(route => location.pathname === route)) {
            setLookOpened(true);
          }
        }
      }
      // console.log("featureSet", featureSet);
      if (featureSet && !getFeatureIsLocked(featureSet)) {
        const parent = featureSet.getParent();
        if (!IS_PRODUCT_JOURNEY || (!parent.activeFeature
          || (parent.activeFeature.dbFeature.sharedFeatureName !== featureSet.dbFeature.sharedFeatureName))) {
          console.log("featureSet from URL", featureSet);
          const useAllWallsApplyLogic = getShowMatchRadio(featureSet);
          if (useAllWallsApplyLogic) { // before nav feature click
            const applyToLogic = getApplyToLogic(featureSet);
            if (applyToLogic && Array.isArray(applyToLogic.currentApplyToArray) && applyToLogic.currentApplyToArray.length) {
              await clickOnSimilarFeatures(featureSet, applyToLogic, true);
            }
          }
          navFeatureCLick(featureSet, false, true); // set feature on load
          updateCanvasCount();
          if (!parent.featureBeforeChange) {
            parent.featureBeforeChange = featureSet;
          }
          // if (canvasScale > 1) {
          //   zoomCanvasOut(imageCanvas, setCanvasScale);
          // }
          // zoomToFeatureGroup(featureSet.partId, featureSet, null, false);
        }
      }
      if (!firstTimeLoaded) {
        firstTimeLoaded = true;
      }
    }
  };

  const updateLocationLogic = () => {
    clearTimeout(timeOut);
    timeOut = setTimeout(lookHistoryListener, 0);
  };

  useEffect(() => {
    updateLocationLogic();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return null

  // return (
  //   <Switch>
  //     <Route path={[ROUTES.lookActiveCategory, ROUTES.lookActiveFeature]}>
  //       <LookRoutingURLParse/>
  //     </Route>
  //   </Switch>
  // )
};

const mapStateToProps = (store) => {
  const {lookOpened, lookActiveCategory, lookActiveFeature, lookPageOpened, lookOverlayOpened} = store.lookState;
  const {activePreset, bvPresets, loadedPresets} = store.bathroomVisualizerState;
  // const {activePreset, bvPresets, canvasScale} = store.bathroomVisualizerState;
  const {visualizersLoaded} = store.serverState;
  const {wizardActiveItem} = store.wizardState;
  return {
    lookOpened,
    lookOverlayOpened,
    lookActiveCategory,
    lookActiveFeature,
    lookPageOpened,
    activePreset,
    loadedPresets,
    bvPresets,
    // canvasScale,
    visualizersLoadedLength: visualizersLoaded.length,
    wizardActiveItem,
  };
};

LookRouting.propTypes = {
  zoomToFeatureGroup: PropTypes.func,
  imageCanvas: PropTypes.object,
}

const mapDispatchToProps = {
  setLookOpened,
  setLookActiveFeature,
  setLookActiveCategory,
  setLookPageOpened,
  updateCanvasCount,
  setLookOverlayOpened,
  // setCanvasScale,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LookRouting)
)
